<script setup lang="ts">
/**
 * An iPhone mockup wrapping an arbitrary screen.
 *
 * Extracted from the RCS preview (RCSView.vue) so the birthday module can
 * show both the conversation and the QR page inside the same frame.
 */
</script>

<template>
  <div class="rcs-phone-frame relative max-w-sm">
    <img
      src="@/assets/images/iphone-mockup-transparent.png"
      class="pointer-events-none w-full object-contain"
      alt="mockup"
    >
    <div
      class="absolute left-1/2 top-[2.8%] flex h-[91.7%] w-[84%] -translate-x-1/2 select-none flex-col overflow-hidden rounded-[2rem]"
    >
      <slot />
    </div>
  </div>
</template>
